import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../lib/api';

/** Fires a single pageview to the backend on every route change.
 *  Anonymous (server-side cookie). Errors are swallowed silently.
 */
export default function PageviewTracker() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname + (location.search || '');
    if (lastPath.current === path) return;
    lastPath.current = path;
    api.post('/track/pageview', { path }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}
